const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
]

const STORAGE_KEY = 'ff-utm-params'
const MAX_VALUE_LENGTH = 512

/**
 * Captures the campaign params present in the page URL, or in the referrer's
 * as a fallback, into session storage. A new set of params replaces the stored
 * one; their absence leaves it untouched.
 */
export function captureUtmParams() {
  if (window.FF_DISABLE_UTM_CAPTURE) return

  const params =
    extractUtmParams(window.location.search) ||
    extractUtmParams(referrerQueryString())

  if (params) storeUtmParams(params)
}

/**
 * @returns {Object|null} The campaign params captured during this session, or
 *                        null if there are none.
 */
export function getUtmParams() {
  if (window.FF_DISABLE_UTM_CAPTURE) return null

  const stored = readStoredUtmParams()
  if (!stored) return null

  const params = {}

  for (const key of UTM_KEYS) {
    const value = stored[key]
    if (typeof value === 'string' && value) params[key] = value
  }

  return Object.keys(params).length ? params : null
}

function extractUtmParams(queryString) {
  if (!queryString) return null

  const searchParams = new URLSearchParams(queryString)
  const params = {}

  for (const key of UTM_KEYS) {
    const value = searchParams.get(key)?.trim().slice(0, MAX_VALUE_LENGTH)
    if (value) params[key] = value
  }

  return Object.keys(params).length ? params : null
}

function referrerQueryString() {
  try {
    return new URL(document.referrer).search
  } catch {
    return null
  }
}

function storeUtmParams(params) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params))
  } catch {}
}

function readStoredUtmParams() {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    const parsed = stored && JSON.parse(stored)

    return parsed && typeof parsed === 'object' ? parsed : null
  } catch {
    return null
  }
}
